import React, { useEffect, useState } from "react";
import classes from "./Login.module.scss";
import { useDispatch } from "react-redux";
import Amplify, { Auth } from "aws-amplify";
import awsconfig from "../../aws-exports";
import * as helpers from "../../helpers";
import * as kUserException from "../../constants/users_login";
// Components
import TagA from "../../components/Buttons/TagA";
import Alert from "../../components/UI/Alerts/Alert";
//Assets
// import { ReactComponent as Logo } from "../../assets/images/logo_afinando_dark.svg";
import { useTranslation } from "react-i18next";
import * as actions from "../../store/actions";
import Spinner from "../../components/UI/Spinner";
import TagCard from "../../components/Cards";
import InitResetPWForm from "../../components/Login/InitResetPWForm";
import LoginForm from "../../components/Login/LoginForm";
import SignUpForm from "../../components/Login/SignUpForm";
import UpdatePWForm from "../../components/Login/UpdatePWForm";
import VerifyCodeForm from "../../components/Login/VerifyCodeForm";
import { useLocation } from "react-router-dom";
import { GET_PROD_OR_DEV, STATIC_PROBRAIN_URL } from "../../constants/api";
import * as defaults from "../../constants/defaults";
import {
  checkIsEqualText,
  validarPatternEmail, validarPatternEmailProvidor,
  get3rdPath,

} from "../../helpers";
import * as kUser from "../../constants/users_login";
import { NavLink, useHistory } from "react-router-dom";

const LOGIN_SCREEN = "LOGIN_SCREEN";
const SIGNUP_SCREEN = "SIGNUP_SCREEN";
const VERIFY_CODE_SCREEN = "VERIFY_CODE_SCREEN";
const INIT_RESET_PW_SCREEN = "INIT_RESET_PW_SCREEN";
const UPDATE_PW_SCREEN = "UPDATE_PW_SCREEN";

Amplify.configure(awsconfig);


const Login = (props) => {
  /**
   * -------------------------------------------
   * IT MUTS TO BE AT THE TOP
   * Define session permission by URL
   */
  //
  let permissions = kUserException.USERTYPE_SINGLE_FREE_PERMISSIONS;
  const secondPath = helpers.get2ndPath(useLocation().pathname);
  const thirdPath = get3rdPath(useLocation().pathname);
  const urlPermission = helpers.getPermitionByURL(secondPath);
  if (urlPermission !== "") permissions = urlPermission;
  // initial login state

  const START_SCREEN = checkIsEqualText(thirdPath, kUser.SIGNUP)
    ? SIGNUP_SCREEN
    : LOGIN_SCREEN;

  let initialLogin = {
    username: "",
    password: "",
    given_name: "",
    verify_codigo: "",
    "custom:permissions": permissions,

  };


  // -------------------------------------------
  // resbolar.resbolar@gmail.com  = user_pro_paid = 100000
  // resbolar.resbolar+1@gmail.com = user_pro_free = 010000
  // resbolar.resbolar+2@gmail.com = user_single_paid = 001000
  // resbolar.resbolar+3@gmail.com = user_single_free = 000100
  // resbolar.resbolar+4@gmail.com = user_family_paid = 000010
  // resbolar.resbolar+5@gmail.com = user_family_free = 000001
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [login, setLogin] = useState(initialLogin);
  const [screen, setScreen] = useState(LOGIN_SCREEN);
  const [errorMsg, setErrorMsg] = useState(null);
  const [errorObject, setErrorObject] = useState({});
  const [spinner, setSpinner] = useState(false);
  const location = useLocation();

  const onChange = (event) => {
    let { value, name } = event.target;
    if (checkIsEqualText(name, kUser.CUSTOM_INVITE_CODE)) {
      value = value.replace(/[^a-zA-Z]+/g, "").toUpperCase();
    } else if (checkIsEqualText(name, kUser.VERIFY_CODIGO)) {
      value = value.replace(/[^0-9]+/g, "").toUpperCase();
    } else if (checkIsEqualText(name, "username")) {
      value = value.toLowerCase();
    } else if (checkIsEqualText(name, kUser.CUSTOM_BIRTH_DATE)) {
      value = value.toUpperCase();
    }
    setLogin(helpers.updateObject(login, { [name]: value }));
  };
  const resetLogin = () => setLogin({ ...login, password: "" });
  const [suggestedEmail, setSuggestedEmail] = useState(null)
  const validateFormSignup = {
    username: () => {
      if (login.username != "" && login.username.includes("@")) {
        const _isInvalidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(login.username)

        if (!_isInvalidEmail) {
          setSuggestedEmail("")
          return {
            type: 'error',
            message: t("global.enter_valid_email_address")
          }
        }
        const emailSplited = login.username.split("@")

        const blockemail = validarPatternEmailProvidor(emailSplited[1])
        // const errorClick = ()=>{props.signUpForm.username= emailSplited[0]+"@"+blockemail}
        if (blockemail) {
          setSuggestedEmail(emailSplited[0] + "@" + blockemail)
          return {
            type: 'error',
            message: t("global.email_address_pattern_error")
          }
        }

        check_email_Server()
      }
    },
    password:()=>{
      const ispassvalid = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/.test(login.password)
      if(login.password && login.password !="" && !ispassvalid) return{
        type: 'error',
        message: t("global.signup_password_failure")
      }
    },
    given_name:()=>{
      const isGivenNameValid = /^(?=.*?[a-zA-Z]).{1,}$/.test(login.given_name)
      if(login.given_name && login.given_name !="" && !isGivenNameValid) return{
        type: 'error',
        message: t("global.signup_nickname_failure")
      }
    },
    [kUser.CUSTOM_BIRTH_DATE]: ()=>{
      const dateInput = login[kUser.CUSTOM_BIRTH_DATE];
      const dateObj = new Date(dateInput)
      console.log('dateInput',dateInput);
      const isValidDate = /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      if(dateInput!==undefined && (!dateObj || !isValidDate)){
        return {
          type: 'error',
          message: t("global.signup_date_failure")
        }
      }

    }
  }
  const onValidateSignUpForm = () => {
    if (screen == SIGNUP_SCREEN) {
      setErrorObject({
        ...errorObject, ...Object.keys(validateFormSignup).reduce((newObj, key) => {
          if (typeof validateFormSignup[key] === 'function') {
            newObj[key] = validateFormSignup[key]()
          } else {
            const regex = new RegExp(validateFormSignup[key]);
            if (login[key] != "" && !regex.test(login[key])) {
              newObj[key] = {
                type: 'error',
                message: t("global.signup_failure")
              }
            } else {
              newObj[key] = false
            }
          }

          return newObj
        }, {})
      })
    }
  }
  useEffect(() => {
    onValidateSignUpForm()
  }, [login])

  const check_email_Server = () => {
    let _signUpUser = {
      username: login.username,
      password: "SenhaDefault123",
    };
    Auth.signUp(_signUpUser)
      .then((res) => {
        console.log(res);
      })
      .catch((errors) => {
        console.log(errors.name);
        const type_error = errors.name
        if (type_error == 'UsernameExistsException') {
          setErrorObject({
            ...errorObject, 'username': {
              type: "error",
              message: t("global.email_address_exist")
            }
          })
          setSuggestedEmail("")
        } else {
          const emailSplited = login.username.split("@")

          const providorSuggested = validarPatternEmail(emailSplited[1])
          if (providorSuggested) {
            const emailSuggested = emailSplited[0] + "@" + providorSuggested;

            setSuggestedEmail(emailSuggested)
            setErrorObject({
              ...errorObject, 'username': {
                type: "warn",
                message: t("global.email_address_pattern_warn")
              }
            })
          } else {
            setErrorObject({ ...errorObject, 'username': false })
            setSuggestedEmail("")
          }
        }
      });
  };
  const setErrorMsgHandler = (error = null, spinner = false) => {
    setSpinner(spinner);
    if (error && error.code) setErrorMsg(helpers.getMsgErrorLogin(error.code));
    else setErrorMsg(null);
  };

  const changeScreenHandler = (screen) => {
    resetLogin();
    setErrorMsgHandler(null);
    setScreen(screen);
  };

  const handleSuccessLogin = () => {
    let queryString = new URLSearchParams(location.search);
    const { redirectTo } = queryString.parse(location.search);
    history.push(redirectTo == null ? "/planos" : redirectTo);
  };
  const history = useHistory();
  // ========== Actions Handler =============
  // LOGIN HANDLER
  const loginActionHandler = (event) => {
    setErrorMsgHandler(null, true);
    event.preventDefault();
    let data = {
      username: login.username,
      password: login.password,
    };
    Auth.signIn(data)
      .then((res) => {
        dispatch(actions.initSessionActive(res));
        setErrorMsgHandler();
        handleSuccessLogin();
        // history.push("/planos");

      })
      .catch((errors) => {
        setErrorMsgHandler(errors);
        if (errors.code === kUserException.USER_NOT_CONFIRMED_EXCEPTION)
          setScreen(VERIFY_CODE_SCREEN);
      });
  };



  // VERIFY CODIGO HANDLER
  const verifyCodigoActionHandler = (event) => {
    setErrorMsgHandler(null, true);
    event.preventDefault();
    Auth.confirmSignUp(login.username, login.verify_codigo)
      .then((res) => {
        changeScreenHandler(LOGIN_SCREEN);
      })
      .catch((errors) => {
        setErrorMsgHandler(errors);
      });
  };
  useEffect(() => {
    const google_sign_in = localStorage.getItem("google_sign_in");
    console.log("google_sign_in", google_sign_in);
    if (google_sign_in == 1) {
      setSpinner(true);
      Auth.currentAuthenticatedUser()
        .then((_cognitoUser) => { localStorage.setItem("google_sign_in", 3); })
        .catch((_err) => {
          // setSuccesMsg("msg_success.success_signup_google");
          const forceCallGoogle = () => {
            setTimeout(() => {
              const google_sign_in2 = localStorage.getItem("google_sign_in");
              console.log("google_sign_in", google_sign_in2);
              if (google_sign_in2 == 1) {
                if (!!!Auth.user) {
                  localStorage.setItem("google_sign_in", 2);
                  Auth.federatedSignIn({
                    provider: 'Google',
                  });
                } else forceCallGoogle();
              }
            }, 3000);
          };
          forceCallGoogle();
        });
    }
  }, []);

  const signInWithGoogle = (event) => {
    if (event) event.preventDefault();

    localStorage.setItem("google_sign_in", 1);
    setSpinner(true);
    Auth.federatedSignIn({
      provider: "Google",
    });
  };

  const signUpActionHandler = (event) => {
    if (event) event.preventDefault();
    // setErrorMsgHandler(null, true);

    let _signUpUser = {
      username: login.username,
      password: login.password,
      attributes: {
        given_name: login.given_name,
        [kUser.CUSTOM_BIRTH_DATE]: login[kUser.CUSTOM_BIRTH_DATE],
        [kUser.CUSTOM_OCCUPATION]: login[kUser.CUSTOM_OCCUPATION],
        [kUser.CUSTOM_START_ACC_TYPE]: login[kUser.CUSTOM_START_ACC_TYPE],
        [kUser.CUSTOM_START_PLATAFORMA]: defaults.WEB,
      },
    };

    if (login[kUser.CUSTOM_INVITE_CODE]) {
      _signUpUser.attributes = {
        ..._signUpUser.attributes,
        [kUser.CUSTOM_INVITE_CODE]: login[kUser.CUSTOM_INVITE_CODE],
      };
    }

    Auth.signUp(_signUpUser)
      .then((res) => {
        setErrorMsgHandler();
        setScreen(VERIFY_CODE_SCREEN);
        if (window.AmplReferral) {
          window.AmplReferral.identify(
            {
              name: login.given_name,
              email: login.username,
              phone: "",
            },
            (data) => { }
          );
        }
      })
      .catch((errors) => {
        setErrorMsgHandler(errors);
      });
  };

  // SIGNUP ACTION HANDLER
  // const signUpActionHandler = (event) => {
  //   setErrorMsgHandler(null, true);
  //   event.preventDefault();
  //   Auth.signUp({
  //     username: login.username,
  //     password: login.password,
  //     attributes: {
  //       given_name: login.given_name,
  //       "custom:permissions": login["custom:permissions"],
  //     },
  //   })
  //     .then((res) => {
  //       setErrorMsgHandler();
  //       setScreen(VERIFY_CODE_SCREEN);
  //     })
  //     .catch((errors) => {
  //       setErrorMsgHandler(errors);
  //     });
  // };

  // INIT RESET PW ACTION HANDLER
  const InitResetPWSubmit = (event) => {
    setErrorMsgHandler(null, true);
    Auth.forgotPassword(login.username)
      .then((res) => {
        setErrorMsgHandler();
        setScreen(UPDATE_PW_SCREEN);
      })
      .catch((errors) => {
        setErrorMsgHandler(errors);
      });
  };

  // UPDATE PW ACTION HANDLER
  const updatePasswordSubmit = (event) => {
    setErrorMsgHandler(null, true);
    event.preventDefault();
    Auth.forgotPasswordSubmit(
      login.username,
      login.verify_codigo,
      login.password
    )
      .then((res) => {
        setErrorMsgHandler();
        setScreen(LOGIN_SCREEN);
      })
      .catch((errors) => {
        setErrorMsgHandler(errors);
      });
  };

  // ========== Contents =============
  const getLoginForm = () => (
    <LoginForm
      errorMsg={errorMsg}
      login={login}
      formSubmit={loginActionHandler}
      onChange={onChange}
      bottomLink={() => changeScreenHandler(INIT_RESET_PW_SCREEN)}
      googleSignIn={signInWithGoogle}
      createAccount={() => changeScreenHandler(SIGNUP_SCREEN)}
    />
  );

  const getVerifyCodeForm = () => (
    <VerifyCodeForm
      errorMsg={errorMsg}
      login={login}
      signout={() => changeScreenHandler(LOGIN_SCREEN)}
      formSubmit={verifyCodigoActionHandler}
      onChange={onChange}
    />
  );

  const getSignUpForm = () => (
    <SignUpForm
      errorMsg={errorMsg}
      login={login}
      errorObject={errorObject}
      formSubmit={signUpActionHandler}
      onChange={onChange}
      suggestedEmail={suggestedEmail}
      onBlur={onValidateSignUpForm}
    />
  );

  const getInitResetPWForm = () => (
    <InitResetPWForm
      errorMsg={errorMsg}
      login={login}
      formSubmit={InitResetPWSubmit}
      onChange={onChange}
      bottomLink={() => changeScreenHandler(LOGIN_SCREEN)}
    />
  );

  const getUpdatePWForm = () => (
    <UpdatePWForm
      errorMsg={errorMsg}
      login={login}
      formSubmit={updatePasswordSubmit}
      onChange={onChange}
      bottomLink={() => changeScreenHandler(LOGIN_SCREEN)}
    />
  );

  let cardContent = <Spinner />;
  let cardClass = spinner
    ? classes.CardLogin + " " + classes.Lopading
    : classes.CardLogin;

  // form de email
  // form 1 senhas
  if (screen && !spinner) {
    switch (screen) {
      case LOGIN_SCREEN:
        if (!spinner) cardContent = getLoginForm();
        break;
      case SIGNUP_SCREEN:
        if (!spinner) cardContent = getSignUpForm();
        break;
      case VERIFY_CODE_SCREEN:
        if (!spinner) cardContent = getVerifyCodeForm();
        break;
      case UPDATE_PW_SCREEN:
        if (!spinner) cardContent = getUpdatePWForm();
        break;
      case INIT_RESET_PW_SCREEN:
        if (!spinner) cardContent = getInitResetPWForm();
        break;
      default:
        cardContent = <Spinner />;
        break;
    }
    cardContent = <TagCard className={cardClass}>{cardContent}</TagCard>;
  }
  const { addlogin } = helpers.getQueryStringParams(useLocation().search);
  if (GET_PROD_OR_DEV === defaults.DEV && !addlogin) {
    cardContent = (
      <TagCard className={cardClass}>
        <Alert
          closeBtn={false}
          text={
            <p>
              {t("global.info_line_1_accessing_devmode")}
              <br />
              <br />
              {t("global.info_line_2_accessing_devmode")}
              <br />
              <br />
              {t("global.info_line_3_accessing_devmode")}
            </p>
          }
          alertType={defaults.ALERT_TYPE_DANGER}
        />
        <TagA
          href={STATIC_PROBRAIN_URL}
          className={classes.BtnEnter}
          text={t("global.access_probrain_account")}
        />
      </TagCard>
    );
  }

  return (

    <main className={classes.Login}>
      <div className="row">
        <div className="col-12">{cardContent}</div>
      </div>
    </main>

  );
};

export default Login;
